export const BASE_URL = process.env.NEXT_PUBLIC_API_URL;
export const GRAPHQL_URL = process.env.NEXT_PUBLIC_GRAPHQL_API_URL;
export const SHARE_URL = process.env.NEXT_PUBLIC_SHARE_URL;

export const APP_NAME = process.env.NEXT_PUBLIC_APP_NAME;
export const APP_DESCRIPTION = process.env.NEXT_PUBLIC_APP_DESCRIPTION;

export const GTM_TAG = process.env.NEXT_PUBLIC_GTM_TAG;
export const FB_PIXEL = process.env.NEXT_PUBLIC_FB_PIXEL;

// basket
export const ENABLE_BASKET = process.env.NEXT_PUBLIC_ENABLE_BASKET ? process.env.NEXT_PUBLIC_ENABLE_BASKET : '';
export const DEFER_BASKET_CHOICES = process.env.NEXT_PUBLIC_DEFER_BASKET_CHOICES ? process.env.NEXT_PUBLIC_DEFER_BASKET_CHOICES : false;

// CDN
export const CDN_URL = process.env.NEXT_PUBLIC_CDN_KEY
	? 'https://cdn.prospectus.plus/' + process.env.NEXT_PUBLIC_CDN_KEY
	: 'https://cdn.prospectus.plus/localdev';
export const CDN_ICON_URL = 'https://cdn.prospectus.plus/prospectus-icons';

// Homepage Copy
export const HOME_TITLE = process.env.NEXT_PUBLIC_HOME_TITLE ? process.env.NEXT_PUBLIC_HOME_TITLE : 'Prospectus';
export const PROSPECTUS_TITLE = process.env.NEXT_PUBLIC_PROSPECTUS_TITLE
	? process.env.NEXT_PUBLIC_PROSPECTUS_TITLE
	: 'Prospectus';
export const HOME_DESCRIPTION = process.env.NEXT_PUBLIC_HOME_DESCRIPTION
	? process.env.NEXT_PUBLIC_HOME_DESCRIPTION
	: "Click 'Create yours now' to create your own personalised prospectus.";

// Homepage buttons
export const HOME_BUTTON_ONE_TEXT = process.env.NEXT_PUBLIC_BUTTON_ONE_TEXT
	? process.env.NEXT_PUBLIC_BUTTON_ONE_TEXT
	: 'Create yours now';
export const HOME_BUTTON_TWO_TEXT = process.env.NEXT_PUBLIC_BUTTON_TWO_TEXT
	? process.env.NEXT_PUBLIC_BUTTON_TWO_TEXT
	: 'Show me everything';
export const HOME_BUTTON_THREE_TEXT = process.env.NEXT_PUBLIC_BUTTON_THREE_TEXT
	? process.env.NEXT_PUBLIC_BUTTON_THREE_TEXT
	: 'My prospectus';
export const HOME_BUTTON_SEPARATOR = process.env.NEXT_PUBLIC_HOME_BUTTON_SEPARATOR
	? process.env.NEXT_PUBLIC_HOME_BUTTON_SEPARATOR
	: '';

// Overview Text
export const OVERVIEW_TITLE = process.env.NEXT_PUBLIC_OVERVIEW_TITLE
	? process.env.NEXT_PUBLIC_OVERVIEW_TITLE
	: 'Your Prospectus';
export const OVERVIEW_DESCRIPTION = process.env.NEXT_PUBLIC_OVERVIEW_DESCRIPTION
	? process.env.NEXT_PUBLIC_OVERVIEW_DESCRIPTION
	: 'Welcome to your prospectus! Take a look round at your refined list of courses and content that is suggested based on your choices.';

// Header Labels
export const HEADER_MY_PROSPECTUS_LABEL = process.env.NEXT_PUBLIC_MY_PROSPECTUS_LABEL
	? process.env.NEXT_PUBLIC_MY_PROSPECTUS_LABEL
	: 'My Prospectus';
export const HEADER_START_OVER_LABEL = process.env.NEXT_PUBLIC_HEADER_START_OVER_LABEL
	? process.env.NEXT_PUBLIC_HEADER_START_OVER_LABEL
	: 'Start Over';

// Personalise, select courses
export const SELECT_COURSES_LABEL = process.env.NEXT_PUBLIC_SELECT_COURSES_LABEL
	? process.env.NEXT_PUBLIC_SELECT_COURSES_LABEL
	: 'Please select your courses';
export const SELECT_COURSES_DESCRIPTION = process.env.NEXT_PUBLIC_SELECT_COURSES_DESCRIPTION
	? process.env.NEXT_PUBLIC_SELECT_COURSES_DESCRIPTION
	: 'Based on your earlier answers, these are the courses that we think you will be most interested in!';
export const PERSONALISE_LOADING_TEXT = process.env.NEXT_PUBLIC_PERSONALISE_LOADING_TEXT
	? process.env.NEXT_PUBLIC_PERSONALISE_LOADING_TEXT
	: 'Hold tight!';
export const PERSONALISE_SELECT_ALL_ENABLED = process.env.NEXT_PUBLIC_PERSONALISE_SELECT_ALL_ENABLED
	? process.env.NEXT_PUBLIC_PERSONALISE_SELECT_ALL_ENABLED
	: 'false';
export const PERSONALISE_SELECT_ALL_LABEL = process.env.NEXT_PUBLIC_PERSONALISE_SELECT_ALL_LABEL
	? process.env.NEXT_PUBLIC_PERSONALISE_SELECT_ALL_LABEL
	: 'Select All';
export const PERSONALISE_ENABLE_COURSE_SEARCH = process.env.NEXT_PUBLIC_ENABLE_COURSE_SEARCH
	? process.env.NEXT_PUBLIC_ENABLE_COURSE_SEARCH
	: 'false';
export const PERSONALISE_SELECT_ALL_COURSES = process.env.NEXT_PUBLIC_PERSONALISE_SELECT_ALL_COURSES
	? process.env.NEXT_PUBLIC_PERSONALISE_SELECT_ALL_COURSES
	: '';
export const CHOSEN_TO_START_OVER = process.env.NEXT_PUBLIC_CHOSEN_TO_START_OVER
	? process.env.NEXT_PUBLIC_CHOSEN_TO_START_OVER
	: 'You have chosen to start over. Continuing will delete your previous prospectus and generate a new one.';
export const PERSONALISE_ANIMATION_TYPE = process.env.NEXT_PUBLIC_PERSONALISE_ANIMATION_TYPE
	? process.env.NEXT_PUBLIC_PERSONALISE_ANIMATION_TYPE
	: '';

// Home Layout
export const HOME_LAYOUT = process.env.NEXT_PUBLIC_HOME_LAYOUT ? process.env.NEXT_PUBLIC_HOME_LAYOUT : 'right';
export const HIDE_EVERYTHING_BUTTON = process.env.NEXT_PUBLIC_HIDE_EVERYTHING_BUTTON ?? false;
export const HIDE_OVERVIEW_BUTTON = process.env.NEXT_PUBLIC_HIDE_OVERVIEW_BUTTON ?? false;
export const HOMEPAGE_VIDEO = process.env.NEXT_PUBLIC_HOMEPAGE_VIDEO ?? false;
export const HOMEPAGE_BUTTON_LAYOUT_MTU = process.env.NEXT_PUBLIC_HOMEPAGE_BUTTONS_LAYOUT_MTU ?? false;
export const LANGUAGES_JSON = JSON.parse(process.env.NEXT_PUBLIC_LANGUAGES_JSON ?? '[]');

// Masthead on frontpage
export const MASTHEAD_ON_FRONT = process.env.NEXT_PUBLIC_MASTHEAD_ON_FRONT ?? false;
export const HP_ANIMATIONS = process.env.NEXT_PUBLIC_ANIMATIONS_ON_HP ?? false;
export const HP_ANIMATION_TYPE = process.env.NEXT_PUBLIC_HP_ANIMATION_TYPE ? process.env.NEXT_PUBLIC_HP_ANIMATION_TYPE : 'fade-in-up';
export const MENU_STICKY =  process.env.NEXT_PUBLIC_MENU_STICKY ?? true;
export const MENU_OFFCANVAS = process.env.NEXT_PUBLIC_MENU_OFFCANVAS && process.env.NEXT_PUBLIC_MENU_OFFCANVAS === 'true' ? 'true' : false;
export const HIDE_HOMEPAGE_LOGO = process.env.NEXT_PUBLIC_HIDE_HOMEPAGE_LOGO ?? false;
export const IS_SPLIT_FOOTER = process.env.NEXT_PUBLIC_IS_SPLIT_FOOTER ?? false;
export const FOOTER_MENU_ITEMS_SECONDARY = process.env.NEXT_PUBLIC_SECONDARY_FOOTER_MENU_ITEMS
	? JSON.parse(process.env.NEXT_PUBLIC_SECONDARY_FOOTER_MENU_ITEMS)
	: '';
export const FOOTER_ADDRESS = process.env.NEXT_PUBLIC_FOOTER_ADDRESS ?? false;
export const MAIN_MENU_ITEMS = JSON.parse(process.env.NEXT_PUBLIC_MAIN_MENU_ITEMS ?? '[]');

// Overview Hero.
export const OVERVIEW_HERO_ALIGNMENT = process.env.NEXT_PUBLIC_OVERVIEW_HERO_ALIGNMENT ?? 'is-align-items-flex-end';
export const OVERVIEW_HERO_JUSTIFICATION =
	process.env.NEXT_PUBLIC_OVERVIEW_HERO_JUSTIFICATION ?? 'is-justify-content-flex-start';
export const OVERVIEW_HERO_TEXT_ALIGNMENT = process.env.NEXT_PUBLIC_OVERVIEW_HERO_TEXT_ALIGNMENT ?? 'has-text-left';
export const OVERVIEW_HERO_IS_VIDEO = process.env.NEXT_PUBLIC_OVERVIEW_HERO_IS_VIDEO ?? false;
export const OVERVIEW_PERS_ICON_IS_DISABLED = process.env.NEXT_PUBLIC_OVERVIEW_PERS_ICON_DISABLE ?? false;
export const OVERVIEW_IS_PERSONALISED = process.env.NEXT_PUBLIC_OVERVIEW_IS_PERSONALISED ?? false;

// Overview Hero Mobile
export const OVERVIEW_HERO_ALIGNMENT_MOBILE =
	process.env.NEXT_PUBLIC_OVERVIEW_HERO_ALIGNMENT_MOBILE ?? 'is-align-items-flex-start--mobile';
export const OVERVIEW_HERO_JUSTIFICATION_MOBILE =
	process.env.NEXT_PUBLIC_OVERVIEW_HERO_JUSTIFICATION_MOBILE ?? 'is-justify-content-flex-end--mobile';
export const OVERVIEW_HERO_TEXT_ALIGNMENT_MOBILE =
	process.env.NEXT_PUBLIC_OVERVIEW_HERO_TEXT_ALIGNMENT_MOBILE ?? 'has-text-left-mobile';

// Should the first section pull over.
export const PULL_FIRST_SECTION_UP =
	process.env.NEXT_PUBLIC_PULL_FIRST_SECTION_UP && 'true' === process.env.NEXT_PUBLIC_PULL_FIRST_SECTION_UP
		? true
		: false;

// CSS Overrides
export const CSS_INSTANCE_CLASS_TARGET = process.env.NEXT_PUBLIC_CSS_INSTANCE_CLASS_TARGET
	? process.env.NEXT_PUBLIC_CSS_INSTANCE_CLASS_TARGET
	: '';
export const MANUAL_CSS_OVERRIDE = process.env.NEXT_PUBLIC_MANUAL_CSS_OVERRIDE ?? '';
export const CSS_OVERRIDE = process.env.NEXT_PUBLIC_CSS_OVERRIDE ?? '';
export const CUSTOM_FONT = process.env.NEXT_PUBLIC_CUSTOM_FONT ?? false;
export const ADOBE_FONT = process.env.NEXT_PUBLIC_ADOBE_FONT ?? false;
export const CUSTOM_CSS = process.env.NEXT_PUBLIC_CUSTOM_CSS ?? false;

export const HIDE_REMOVE_CONTENT_INSTANCE_WIDE = process.env.NEXT_PUBLIC_HIDE_REMOVE_CONTENT_INSTANCE_WIDE
	? true
	: false;

// Footer
export const FOOTER_MENU_ITEMS = process.env.NEXT_PUBLIC_FOOTER_MENU_ITEMS
	? JSON.parse(process.env.NEXT_PUBLIC_FOOTER_MENU_ITEMS)
	: '';

// Theme colours.
export const THEME_COLOUR = process.env.NEXT_PUBLIC_THEME_COLOUR ?? '#fff';

//
export const NO_CAROUSEL_OVERLAY = process.env.NEXT_PUBLIC_NO_CAROUSEL_OVERLAY === 'true';
export const OVERVIEW_PUSHED = process.env.NEXT_PUBLIC_OVERVIEW_PUSHED ?? true;

export const VERSION_LITE = process.env.NEXT_PUBLIC_VERSION_LITE ?? false;

export const ROWS_WRAP =
	process.env.NEXT_PUBLIC_ROWS_WRAP && 'true' === process.env.NEXT_PUBLIC_ROWS_WRAP ? true : false;

export const CUSTOM_NAME = process.env.NEXT_PUBLIC_CUSTOM_NAME ?? 'Prospectus';

export const CUSTOM_EXPLORE_DESCRIPTION =
	process.env.NEXT_PUBLIC_CUSTOM_EXPLORE_DESCRIPTION ??
	'Below you can find all of our content to help you decide where you would like to study.';
export const CUSTOM_EXPLORE_TITLE = process.env.NEXT_PUBLIC_CUSTOM_EXPLORE_TITLE ?? 'Explore';

export const GUTENBERG_PALETTE = process.env.NEXT_PUBLIC_GUTENBERG_PALETTE ? true : false;
export const WALLED_GARDEN = process.env.NEXT_PUBLIC_WALLED_GARDEN ? true : false;
export const MEMBERS_ONLY = process.env.NEXT_PUBLIC_MEMBERS_ONLY ? true : false;

// Temp variable.
export const IS_UA92 = process.env.NEXT_PUBLIC_IS_UA92 ? true : false;

// HOLDING PAGE.
export const ENABLE_HOLDING_PAGE = process.env.NEXT_PUBLIC_ENABLE_HOLDING_PAGE ?? false;
export const HOLDING_PAGE_TITLE = process.env.NEXT_PUBLIC_HOLDING_PAGE_TITLE ?? 'Our new prospectus is coming soon!';
export const HOLDING_PAGE_CONTENT = process.env.NEXT_PUBLIC_HOLDING_PAGE_CONTENT ?? '';
export const HOLDING_PAGE_BUTTON_TEXT = process.env.NEXT_PUBLIC_HOLDING_PAGE_BUTTON_TEXT ?? 'Find out more';
export const HOLDING_PAGE_BUTTON_LINK = process.env.NEXT_PUBLIC_HOLDING_PAGE_BUTTON_LINK ?? false;

export const ENABLE_IFRAME_RESIZER = process.env.NEXT_PUBLIC_ENABLE_IFRAME_RESIZER ?? false;

export const COURSE_SELECTOR_VERSION = process.env.NEXT_PUBLIC_COURSE_SELECTOR_VERSION ?? '1';

// DOWNLOAD PROSPECTUS BUTTON.
export const DOWNLOAD_PROSPECTUS_BUTTON_TEXT =
	process.env.NEXT_PUBLIC_DOWNLOAD_PROSPECTUS_BUTTON_TEXT ?? 'Make available offline';

// Hide back buttons.
export const HIDE_BACK_BUTTONS = process.env.NEXT_PUBLIC_HIDE_BACK_BUTTONS ?? false;

// OG Tags for homepage.
export const HOME_OG_IMAGE = process.env.NEXT_PUBLIC_HOME_OG_IMAGE ?? false;
export const HOME_OG_TITLE = process.env.NEXT_PUBLIC_HOME_OG_TITLE ?? false;
export const HOME_OG_DESCRIPTION = process.env.NEXT_PUBLIC_HOME_OG_DESCRIPTION ?? false;

// Auth Translations
export const AUTH_LOGIN_HEADER_STEP_ONE = process.env.NEXT_PUBLIC_AUTH_LOGIN_HEADER_STEP_ONE ?? 'Log in or Register';
export const AUTH_LOGIN_HEADER_STEP_TWO = process.env.NEXT_PUBLIC_AUTH_LOGIN_HEADER_STEP_TWO ?? "We've sent you a code";
export const AUTH_LOGIN_SUB_HEADER_STEP_ONE =
	process.env.NEXT_PUBLIC_AUTH_LOGIN_SUB_HEADER_STEP_ONE ?? 'Enter your email address to get started.';
export const AUTH_LOGIN_SUB_HEADER_STEP_TWO =
	process.env.NEXT_PUBLIC_AUTH_LOGIN_SUB_HEADER_STEP_TWO ?? 'Check your email inbox and enter the code';
export const AUTH_LOGIN_CONTINUE_BTN_STEP_ONE = process.env.NEXT_PUBLIC_AUTH_LOGIN_CONTINUE_BTN_STEP_ONE ?? 'Continue';

export const AUTH_LOGIN_LOADER_TEXT = process.env.NEXT_PUBLIC_AUTH_LOGIN_LOADER_TEXT ?? 'Logging you in';
export const AUTH_LOGIN_FAILED_LOGIN =
	process.env.NEXT_PUBLIC_AUTH_LOGIN_FAILED_LOGIN ?? 'Enter an email to login or register';

export const AUTH_REGISTER_BTN_TEXT = process.env.NEXT_PUBLIC_REGISTER_BTN_TEXT ?? 'Register';
export const AUTH_REGISTER_LOADER_TITLE =
	process.env.NEXT_PUBLIC_AUTH_REGISTER_LOADER_TITLE ?? 'Setting up your account';
export const AUTH_REGISTER_LOADER_DESCRIPTION =
	process.env.NEXT_PUBLIC_AUTH_REGISTER_LOADER_DESCRIPTION ?? 'Hold tight, we are creating your brand new account';

export const AUTH_REGISTER_HEADER_STEP_ONE = process.env.NEXT_PUBLIC_AUTH_REGISTER_HEADER_STEP_ONE ?? 'Almost there!';
export const AUTH_REGISTER_SUB_HEADER_STEP_ONE =
	process.env.NEXT_PUBLIC_AUTH_LOGIN_SUB_HEADER_STEP_ONE ?? 'We need a few final details from you.';

export const AUTH_REGISTER_HEADER_STEP_TWO =
	process.env.NEXT_PUBLIC_AUTH_REGISTER_HEADER_STEP_TWO ?? "We've sent you a code";
export const AUTH_REGISTER_SUB_HEADER_STEP_TWO =
	process.env.NEXT_PUBLIC_AUTH_REGISTER_SUB_HEADER_STEP_TWO ?? 'Check your email inbox and enter the code';

export const AUTH_REGISTER_LOGIN_BTN_TEXT = process.env.NEXT_PUBLIC_AUTH_REGISTER_LOGIN_BTN_TEXT ?? 'Login.';
export const AUTH_ALREADY_HAVE_ACCOUNT =
	process.env.NEXT_PUBLIC_AUTH_ALREADY_HAVE_ACCOUNT ?? 'Already have an account?';
export const AUTH_LOGIN_IF_NO_ACCOUNT = process.env.NEXT_PUBLIC_AUTH_LOGIN_IF_NO_ACCOUNT ?? 'Log in';

export const AUTH_LOGIN_PLACEHOLDER_EMAIL = process.env.NEXT_PUBLIC_AUTH_LOGIN_PLACEHOLDER_EMAIL ?? 'example@email.com';
export const AUTH_LOGIN_WELCOME_BACK = process.env.NEXT_PUBLIC_AUTH_LOGIN_WELCOME_BACK ?? 'Welcome back';

export const PAGE_NOT_FOUND_MESSAGE =
	process.env.NEXT_PUBLIC_PAGE_NOT_FOUND_MESSAGE ??
	"Page not found! Sorry, we couldn't find the page you were looking for.";

export const HEADER_LOGIN_OR_REGISTER_BUTTON =
	process.env.NEXT_PUBLIC_HEADER_LOGIN_OR_REGISTER_BUTTON ?? 'Log in or Register';

// Advisor Translations
export const ADVISOR_PAGE_HEADING = process.env.NEXT_PUBLIC_ADVISOR_PAGE_HEADING ?? 'Advisor Mode';
export const ADVISOR_PAGE_CREATE_NEW = process.env.NEXT_PUBLIC_ADVISOR_PAGE_CREATE_NEW ?? 'Create New';
export const ADVISOR_PAGE_EMPTY_MESSAGE =
	process.env.NEXT_PUBLIC_ADVISOR_EMPTY_MESSAGE ?? "I'm sorry we couldn't find any results!";
export const ADVISOR_PAGE_GENERATE = process.env.NEXT_PUBLIC_ADVISOR_PAGE_GENERATE ?? 'Generate your';
export const ADVISOR_PAGE_BY_SELECTING =
	process.env.NEXT_PUBLIC_ADVISOR_PAGE_BY_SELECTING ?? 'prospectus by selecting a few multiple choice questions';
export const ADVISOR_PAGE_FAVOURITES = process.env.NEXT_PUBLIC_ADVISOR_PAGE_FAVOURITES ?? 'My Favourites';
export const ADVISOR_PAGE_RECENTS = process.env.NEXT_PUBLIC_ADVISOR_PAGE_RECENTS ?? 'Recently Created';

// Share page
export const SHARE_PAGE_TITLE = process.env.NEXT_PUBLIC_SHARE_PAGE_TITLE ?? 'Share your prospectus';
export const SHARE_PAGE_SUB_HEADER = process.env.NEXT_PUBLIC_SHARE_PAGE_SUB_HEADER ?? 'Copy and share this link:';
export const SHARE_PAGE_AUTHENTICATED =
	process.env.NEXT_PUBLIC_SHARE_PAGE_AUTHENTICATED ??
	"To share this prospectus, you'll need to sign up/login. Follow the link below to do that";
export const SHARE_PAGE_AUTHENTICATED_SHORT =
	process.env.NEXT_PUBLIC_SHARE_PAGE_AUTHENTICATED_SHORT ?? 'You must login to share your prospectus';

// Buttons
export const BUTTONS_LOGOUT = process.env.NEXT_PUBLIC_BUTTONS_LOGOUT ?? 'Log Out';
export const BUTTONS_BACK = process.env.NEXT_PUBLIC_BUTTONS_BACK ?? 'Back';
export const BUTTONS_RETURN_HOME = process.env.NEXT_PUBLIC_BUTTONS_RETURN_HOME ?? 'Return to homepage';
export const BUTTONS_ADMIN_TOOLS = process.env.NEXT_PUBLIC_BUTTONS_ADMIN_TOOLS ?? 'Administrator Tools';
export const BUTTONS_SHARE = process.env.NEXT_PUBLIC_BUTTONS_SHARE ?? 'Share';
export const BUTTONS_CONTINUE = process.env.NEXT_PUBLIC_BUTTONS_CONTINUE ?? 'Continue';
export const BUTTONS_LOADING = process.env.NEXT_PUBLIC_BUTTONS_LOADING ?? 'Loading';
export const BUTTONS_SELECT_ALL = process.env.NEXT_PUBLIC_BUTTONS_SELECT_ALL ?? 'Select All';
export const BUTTONS_DESELECT_ALL = process.env.NEXT_PUBLIC_BUTTONS_DESELECT_ALL ?? 'Deselect All';
export const BUTTONS_SELECT = process.env.NEXT_PUBLIC_BUTTONS_SELECT ?? 'Select';
export const BUTTONS_DESELECT = process.env.NEXT_PUBLIC_BUTTONS_DESELECT ?? 'Deselect';

export const LABEL_POWERED_BY = process.env.NEXT_PUBLIC_LABEL_POWERED_BY ?? 'Powered By';
export const LABEL_ADVISOR_MODE = process.env.NEXT_PUBLIC_LABEL_ADVISOR_MODE ?? 'You are currently in Advisor Mode';

export const LABEL_TOS_AGREE =
	process.env.NEXT_PUBLIC_LABEL_TOS_AGREE ?? 'By continuing, you must agree to Prospectus Plus ';
export const LABEL_TOS = process.env.NEXT_PUBLIC_LABEL_TOS ?? 'Terms and Conditions';

export const OVERVIEW_REFINE_SELECTION =
	process.env.NEXT_PUBLIC_OVERVIEW_REFINE_SELECTION ?? 'Refine your selection further';
export const OVERVIEW_ADD_MORE = process.env.NEXT_PUBLIC_OVERVIEW_ADD_MORE ?? 'Add more!';
export const OVERVIEW_ADD_MORE_ADD_MORE_ENABLED = process.env.NEXT_PUBLIC_OVERVIEW_ADD_MORE_ENABLED ?? '';
export const OVERVIEW_REMOVED_CONTENT = process.env.NEXT_PUBLIC_OVERVIEW_REMOVED_CONTENT ?? 'Removed content';
export const OVERVIEW_REMOVED_CONTENT_DESCRIPTION =
	process.env.NEXT_PUBLIC_OVERVIEW_REMOVED_DESCRIPTION ??
	'Here you can see all of the content you have removed from your prospectus combined just in case you clicked the wrong button and want to add them back in!';

// WG mode fields.
export const WG_MODE_TITLE = process.env.NEXT_PUBLIC_WG_MODE_TITLE ?? 'One more thing...';
export const WG_MODE_DESCRIPTION =
	process.env.NEXT_PUBLIC_WG_MODE_DESCRIPTION ??
	'We are busy getting everything ready for your personalised prospectus, help us make your prospectus awesome by filling in the details below.';
export const WG_MODE_FIRST_NAME = process.env.NEXT_PUBLIC_WG_MODE_FIRST_NAME ?? 'First Name';
export const WG_MODE_LAST_NAME = process.env.NEXT_PUBLIC_WG_MODE_LAST_NAME ?? 'Last Name';
export const WG_MODE_EMAIL = process.env.NEXT_PUBLIC_WG_MODE_EMAIL ?? 'Email';
export const WG_MODE_REG_FORM_SUBMIT_BUTTON =
	process.env.NEXT_PUBLIC_WG_MODE_REG_FORM_SUBMIT_BUTTON ?? 'Create ' + CUSTOM_NAME;
export const WG_MODE_REFRESH_FORM_SUBMIT_BUTTON =
	process.env.NEXT_PUBLIC_WG_MODE_REFRESH_FORM_SUBMIT_BUTTON ?? 'Create New ' + CUSTOM_NAME;
export const WG_MODE_FORM_SUBMIT_LOADING =
	process.env.NEXT_PUBLIC_WG_MODE_FORM_SUBMIT_LOADING ?? 'Creating ' + CUSTOM_NAME + '...';

export const WG_MODE_FIRST_NAME_PLACEHOLDER =
	process.env.NEXT_PUBLIC_WG_MODE_FIRST_NAME_PLACEHOLDER ?? 'Enter your first name...';
export const WG_MODE_LAST_NAME_PLACEHOLDER =
	process.env.NEXT_PUBLIC_WG_MODE_LAST_NAME_PLACEHOLDER ?? 'Enter your last name...';
export const WG_MODE_EMAIL_PLACEHOLDER = process.env.NEXT_PUBLIC_WG_MODE_EMAIL_PLACEHOLDER ?? 'Enter your email...';

// INTEGRATIONS.
export const ENABLE_PATHWAYS = process.env.NEXT_PUBLIC_ENABLE_PATHWAYS ?? '';

// TRANSLATIONS
export const TRANSLATIONS_ENABLED = process.env.NEXT_PUBLIC_ENABLE_TRANSLATIONS ?? false;
export const TRANSLATIONS_LOCALE = process.env.NEXT_PUBLIC_LANGUAGE_GROUP
	? process.env.NEXT_PUBLIC_LANGUAGE_GROUP
	: 'default';

export const USE_VIP_BLOCK_DATA = process.env.NEXT_PUBLIC_USE_VIP_BLOCK_DATA ?? false;
